<div class="surface-card shadow-2 border-round p-4 flex flex-column h-full">
  <div class="flex align-items-center justify-content-between mb-3">
    <span class="flex align-items-center">
      <div class="bg-orange-100 border-round p-2 mr-2">
        <i class="pi pi-clipboard text-orange-500"></i>
      </div>
      <span class="block text-900 font-medium text-lg">Últimos Presupuestos</span>
    </span>
  </div>
  <p-divider class="mt-0"></p-divider>
  <div class="flex-column gap-3">
    @for (budget of budgets().data; track $index) {
    <div
      class="flex justify-content-between align-items-center p-3 border-round hover:surface-100 cursor-pointer transition-duration-150 mb-2 border-1 surface-border"
      (click)="goToBudget(budget.id)">
      <div class="flex align-items-center">
        <i class="pi pi-calendar text-500 mr-2"></i>
        <span class="text-700 font-medium text-sm">
          {{ budget.attributes.createdAt | date : "dd/MM/yyyy" }}
        </span>
      </div>
      <div class="flex align-items-center">
        <span class="text-900 font-medium mr-2">
          {{ budget?.attributes?.name ?? "Sin nombre" }}
        </span>
        <i class="pi pi-chevron-right text-400 text-xs"></i>
      </div>
    </div>
    }
  </div>
</div>